import { EntityService } from './EntityService';
import { ICLComFramework } from '../types';

export class CLComFrameworkService extends EntityService<ICLComFramework> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/CLComFrameworks`);
    }

        public readAllForLookup(includeClosedEntities?: boolean, additionalFields?: string): Promise<ICLComFramework[]> {
            return this.readAll(
                `?$select=ID,Title${additionalFields ? `,${additionalFields}` : ''}`
                + `&$orderby=Title`
            );
        }
}